export class ProductDefaultLoi {
    /**
     *
     */
    constructor(productId: number, defaultLoi: number) {
        this.productId = productId;
        this.defaultLoi = defaultLoi;
    }
    productId: number;
    defaultLoi: number;
}